// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  orgOriginKey: __t.string().name("org_origin_key"),
  orgId: __t.string().name("org_id"),
  origin: __t.string(),
  addedBy: __t.identity().name("added_by"),
  addedAt: __t.timestamp().name("added_at"),
});
